import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "../../../../../shared/shared.module";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { LoaderModule } from "../../../../../shared/components/loader/loader.module";
import { OriginChartComponent } from "./origin-chart.component";

@NgModule({
  declarations: [
    OriginChartComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    LoaderModule
  ],
  exports: [
    OriginChartComponent
  ]
})
export class OriginChartModule { }